import React from 'react';
import NemCtrl from './NemCtrl.js';
import Checkbox from 'material-ui/Checkbox';

export default class RothCheckBox extends NemCtrl {
  style = {
    default: {
      color: 'blue',
      display: 'inline-block',
    },
  };
  handleChange = event => this.props.fn(this.props.param, !this.props.value);
  render = () => (
    <Checkbox
      className="CheckBox"
      iconStyle={this.getStyle()}
      checked={this.props.value}
      onCheck={this.handleChange}
      label={this.props.children}
      disabled={this.props.disabled}
    />
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/RothCheckBox.js
 **/